import React from 'react';
import { SettingOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import type { EacProjectItem } from '../../../api';

const CostCheckIcon: React.FC = () => {
  return (
    <svg
      viewBox="0 0 1184 1024"
      className="h-[16px] w-[16px]"
      aria-hidden="true"
    >
      <path
        d="M982.78577 764.55339l183.898823 184.495898a42.392261 42.392261 0 1 1-59.70741 59.70741l-185.092972-184.794435a468.106097 468.106097 0 0 1-298.537052 108.070413A465.419264 465.419264 0 0 1 268.685142 767.53876c-44.482021-52.243984 22.987353-100.905524 74.037188-44.780558a380.634741 380.634741 0 0 0 549.606713 13.434168 388.098167 388.098167 0 0 0 82.9933-123.892877 383.620112 383.620112 0 0 0 0-288.983866v-1.791222A378.246445 378.246445 0 0 0 895.61295 199.124214l-2.089759-2.08976a383.321575 383.321575 0 0 0-123.892876-82.396226 367.200574 367.200574 0 0 0-145.686082-29.853705 381.828889 381.828889 0 0 0-347.795665 228.082307 42.093724 42.093724 0 0 1-39.108354 25.077113 42.690798 42.690798 0 0 1-38.809817-59.707411A470.494394 470.494394 0 0 1 623.645696 0a469.001708 469.001708 0 0 1 329.883442 136.431433l2.388297 2.089759a473.479764 473.479764 0 0 1 98.517227 149.268526v2.388296a463.926579 463.926579 0 0 1 0 353.766407 470.494394 470.494394 0 0 1-71.94743 119.414821z m-957.408326-179.122231a25.375649 25.375649 0 0 1-25.375649-25.674187 25.674186 25.674186 0 0 1 25.375649-25.674186h188.973954L328.392552 343.914684a25.674186 25.674186 0 0 1 34.928835-9.254649 25.375649 25.375649 0 0 1 8.359037 8.657575l109.861636 176.435397 54.63228-57.617651a25.972724 25.972724 0 0 1 36.42152 0 29.853705 29.853705 0 0 1 5.373667 7.761964L640.960845 597.074104l78.813782-332.271739a25.674186 25.674186 0 0 1 29.853705-18.807834 25.375649 25.375649 0 0 1 11.941482 6.567815l116.130913 117.623598a25.674186 25.674186 0 1 1-36.720057 35.824446l-83.590375-84.485985-83.291837 356.751777a22.987353 22.987353 0 0 1-13.732704 16.718075 24.181501 24.181501 0 0 1-33.43615-10.747334l-78.813782-160.01586-51.64691 54.035206a15.822464 15.822464 0 0 1-5.970741 4.776593 25.375649 25.375649 0 0 1-35.227372-7.761963l-105.085042-168.374897-98.815764 164.792452a24.480038 24.480038 0 0 1-22.390279 13.732705H25.377444z"
        fill="#ffffff"
      />
    </svg>
  );
};

interface ProjectSidebarProps {
  projects: EacProjectItem[];
  selectedProjectCode?: string;
  onProjectChange: (projectCode: string | undefined) => void;
  loading: boolean;
  disabled?: boolean;
  detecting?: boolean;
  onStartDetect: () => void;
}

const ProjectSidebar: React.FC<ProjectSidebarProps> = ({
  projects,
  selectedProjectCode,
  onProjectChange,
  loading,
  disabled = false,
  detecting = false,
  onStartDetect,
}) => {
  return (
    <aside className="h-full w-full border-0 border-r border-solid border-[#d9dee7] bg-[#fbfcfe] px-5 py-6">
      <div className="text-[14px] font-semibold leading-6 text-[#1f2937]">
        选择项目
      </div>

      <Select
        value={selectedProjectCode}
        placeholder="-- 选择一个项目 --"
        loading={loading}
        disabled={disabled}
        allowClear
        className="mt-3 w-full [&_.ant-select-selection-item]:text-[13px] [&_.ant-select-selection-placeholder]:text-[13px]"
        size="large"
        onChange={value => onProjectChange(value)}
        options={projects.map(project => ({
          value: project.code,
          label: project.name,
        }))}
      />

      <button
        type="button"
        disabled={!selectedProjectCode || disabled || loading}
        onClick={onStartDetect}
        className="mx-auto mt-8 flex h-10 w-[178px] cursor-pointer items-center justify-center gap-2 rounded-md border-none bg-[#55b4ff] px-4 text-[13px] font-medium text-white transition-colors duration-200 hover:bg-[#3aa6ff] active:bg-[#2198fb] disabled:cursor-not-allowed disabled:bg-[#bcdfff]"
      >
        <CostCheckIcon />
        <span>{detecting ? '检测中...' : '立即检测成本变化'}</span>
      </button>

      <div className="mt-2 flex items-center justify-center gap-2 text-[12px] leading-5 text-[#6b7280]">
        <span>每 3 h自动检测一次</span>
        <SettingOutlined className="text-[#129bfe]" />
      </div>
    </aside>
  );
};

export default ProjectSidebar;
